import { AutofillHome } from "components/AutoFill/AutofillHome";
import { Header } from "components/DesignSystem/Header/Header";
import Tab from "components/DesignSystem/Tab/Tab";
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import "../../static/styles/components/deals.css";
import "../../static/styles/components/entity.css";
import { AutofillPage } from "components/AutoFill/AutofillPage";
import EntityDetail from "./EntityDetail";
import { DashboardLayout } from "components/DashboardLayout";
import { BrandOverview } from "v2/components/brandOverview/BrandOverview";

const EntitiesHeader = ({ url }: { url: string }) => {
  const { pathname } = useLocation();

  return (
    <Header
      v2
      title="My Entities"
      bottom={
        <Tab.Root defaultValue={pathname} value={pathname}>
          <Tab.List>
            <Tab.NavTrigger exact value={url}>
              Overview
            </Tab.NavTrigger>
            <Tab.NavTrigger exact value={`${url}/autofill`}>
              Autofill
            </Tab.NavTrigger>
          </Tab.List>
        </Tab.Root>
      }
    />
  );
};

export const Entities = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <DashboardLayout>
          <div className="t-mx-auto t-w-full t-max-w-[1280px]">
            <BrandOverview />
          </div>
        </DashboardLayout>
      </Route>

      <Route path={`${path}/entity/:entityId`} component={EntityDetail} />
    </Switch>
  );
};
